import React, { Component } from 'react'
import { APIURL } from '../../config/config'
import axios from 'axios'
import { AlertSuccess } from '../Alert/Alert'
import Switch from 'react-switch'
import Swal from 'sweetalert2'
import {connect} from "react-redux";

class CarSellListPaySetting extends Component{
  constructor (props) {
    super(props);

    this.state = {
      actionType: "บันทึก",
      car_sell_list_pay: [],
      car_sell_list_pay_id: '',
      car_sell_list_pay_name: '',
      user: {},
    }

    this.loadCarSellListPayData = this.loadCarSellListPayData.bind(this);
    this.saveCarSellListPay = this.saveCarSellListPay.bind(this);
    this.setEditForm = this.setEditForm.bind(this);
    this.clearForm = this.clearForm.bind(this);
    this.deleteCarSellListPay = this.deleteCarSellListPay.bind(this);
  }

  loadCarSellListPayData () {
    axios.get(APIURL + '/car_sell_list_pay/')
        .then(res => {
          this.setState({car_sell_list_pay: res.data})
          //console.log(res.data)
          //alert (res.data)
        }).catch(error => {
      this.setState({car_sell_list_pay: []})
    })
  }

  deleteCarSellListPay(car_sell_list_pay){
    let car_sell_list_pay_id = car_sell_list_pay.car_sell_list_pay_id
    let car_sell_list_pay_name = car_sell_list_pay.car_sell_list_pay_name

    let data = {
      car_sell_list_pay_id: car_sell_list_pay_id,
      status_field: 'hidden'
    }

    Swal.fire({
      title: 'ยืนยันการลบ '+car_sell_list_pay_name+' ?',
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        let url = APIURL+'/car_sell_list_pay/status'
        axios.post(url, data).then(res => {
          if(res.data === 'success') {
            AlertSuccess('ลบข้อมูลแล้ว')
            this.loadCarSellListPayData()
          }
        })
      }
    });

  }

  saveCarSellListPay() {
    //let username = this.state.user.user
    let actionType = this.state.actionType
    let car_sell_list_pay_name = this.state.car_sell_list_pay_name
    let user = this.state.user.user

    let data= {
      car_sell_list_pay_name,
      user
    }

    if(actionType === "บันทึก") {
      let url = APIURL+'/car_sell_list_pay'
      axios.post(url, data).then(res => {
        if(res.data === 'success') {
          AlertSuccess('บันทึกข้อมูลแล้ว')
          this.clearForm()
          this.loadCarSellListPayData()
        }
      })
    } else if (actionType === "แก้ไข") {
      let car_sell_list_pay_id = this.state.car_sell_list_pay_id
      data = {...data, car_sell_list_pay_id: car_sell_list_pay_id }
      let url = APIURL+'/car_sell_list_pay/'+car_sell_list_pay_id
      axios.put(url, data).then(res => {
        if(res.data === 'success') {
          AlertSuccess('แก้ไขข้อมูลแล้ว')
          this.clearForm()
          this.loadCarSellListPayData()
        }
      })
    }
  }

  setEditForm(car_sell_list_pay) {
    this.setState({
      actionType: 'แก้ไข',
      car_sell_list_pay_name: car_sell_list_pay.car_sell_list_pay_name,
      car_sell_list_pay_id: car_sell_list_pay.car_sell_list_pay_id,
    })
  }

  clearForm() {
    this.setState({
      actionType: "บันทึก",
      car_sell_list_pay_name: '',
      car_sell_list_pay_id: '',
    })
  }

  componentWillMount() {
    this.setState({
      user: JSON.parse(this.props.user),
    })
  }

  componentDidMount () {
    this.loadCarSellListPayData()
  }

  render () {

    return (
      <div className="row">
        <div className="col-sm-7">
          <div className="card card-accent-info">
            <div className="card-header">
              <strong className="text-title">
                รายการรับชำระ
              </strong>
            </div>

            <div className="card-block" style={styles.overflowY}>
              <table className="table table-striped table-responsive">
                <thead>
                <tr>
                  <th className="text-center">#</th>
                  <th className="text-center text-nowrap">รายการรับชำระ</th>
                  <th className="text-center">จัดการ</th>
                </tr>
                </thead>
                <tbody>
                {
                  this.state.car_sell_list_pay.map((car_sell_list_pay, index) => (
                    <tr key={index}>
                      <td className="text-center" style={{width: 10}}>{ index+1 }</td>
                      <td className="text-center text-nowrap" style={{width: 80}}>{ car_sell_list_pay.car_sell_list_pay_name }</td>
                      <td className="text-center" style={{width: 120}}>
                        {
                          car_sell_list_pay.car_sell_list_pay_name === 'เงินจอง' || car_sell_list_pay.car_sell_list_pay_name === 'ค่างวดล่วงหน้า' ?
                              (
                                  <button type="button"
                                          className="btn btn-secondary mr-2 mb-2"
                                          onClick={()=> {

                                          }}
                                          disabled={true}
                                  >
                                    <i className="fa fa-edit"/>
                                  </button>
                              ) : (
                              <button type="button"
                                      className="btn btn-warning mr-2 mb-2"
                                      onClick={() => this.setEditForm(car_sell_list_pay)}
                              >
                                <i className="fa fa-edit"/>
                              </button>
                          )
                        }

                        {
                          car_sell_list_pay.car_sell_list_pay_name === 'เงินจอง' || car_sell_list_pay.car_sell_list_pay_name === 'ค่างวดล่วงหน้า' ?
                              (
                                  <button type="button"
                                          className="btn btn-secondary mr-2 mb-2"
                                          onClick={()=> {

                                          }}
                                          disabled={true}
                                  >
                                    <i className="fa fa-trash"/>
                                  </button>
                              ) : (
                                  <button type="button"
                                          className="btn btn-danger mr-2 mb-2"
                                          onClick={() => this.deleteCarSellListPay(car_sell_list_pay)}
                                  >
                                    <i className="fa fa-trash"/>
                                  </button>
                              )
                        }
                      </td>
                    </tr>
                  ))
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="col-sm-5">
          <div className="card card-accent-success">
            <div className="card-header card-customer">
              <strong className="text-title">เพิ่ม/แก้ไขรายการรับชำระ</strong>
            </div>

            <div className="card-block">
              <div className="form-group">
                <label htmlFor="car_sell_list_pay_name">รายการรับชำระ</label>
                <input
                  value={this.state.car_sell_list_pay_name}
                  type="text"
                  className="form-control"
                  name="car_sell_list_pay_name"
                  placeholder=""
                  style={styles.inputSearch}
                  onChange={(e) => {
                    this.setState({
                      car_sell_list_pay_name: e.target.value
                    })
                  }}
                />
              </div>
            </div>

            <div className="card-footer text-right">
              <button type="button"
                      className="btn btn-sm btn-danger mr-2"
                      style={styles.button}
                      onClick={()=> this.clearForm()}
              >
                <i className="fa fa-refresh"/> ยกเลิก
              </button>

              <button type="button"
                      className={this.state.actionType==="แก้ไข"?  "btn btn-sm btn-warning" : "btn btn-sm btn-primary"}
                      style={styles.button}
                      onClick={() => {
                        this.saveCarSellListPay()
                      }}
              >
                <i className={this.state.actionType === "แก้ไข" ? "fa fa-edit" : "fa fa-save"}/> {this.state.actionType}
              </button>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated
})


const styles = {
  button: {
    borderRadius:5,
    height: 36,
  },
  inputSearch: {
    borderRadius:5,
  },
  overflowY: {
    overflow: 'scroll',
  }
}

export default connect(mapStateToProps)(CarSellListPaySetting)
